import React from "react";
import { useQuery } from "react-query";
import { invariant } from "@gonoodle/gn-universe-utils";

// Registered components
const components = {};

// Registered fetchers
const fetchers = {};

export default function LayoutRenderer({ layout = [] }) {
  return layout.map(({ key, type, templateOptions, fetcher }) => {
    // Check if the component type is registered
    if (type in components) {
      // Render the component with its templateOptions
      const Component = components[type];
      return (
        <Component
          key={key}
          templateOptions={templateOptions}
          fetchers={fetcher}
        />
      );
    }
    // If the component type is not registered, render an error message
    invariant(
      false,
      `LayoutRenderer: Component type ${type} is not registered`,
    );

    return null;
  });
}

export function useDataLoader({ resolver, params = {} }) {
  const { data, isLoading } = useQuery(
    [resolver, ...Object.values(params)],
    () => fetchers[resolver](params),
  );
  return { data, isLoading };
}

export function registerComponent(type, Component) {
  components[type] = Component;
}

export function registerFetcher(resolver, fetcher) {
  fetchers[resolver] = fetcher;
}
